import { Injectable } from '@angular/core';
import {navigation} from './navigation/navigation';
import { ProjectModel } from '@features/projects/models/projects.models';
import { Configuration } from '@shared/models/configuration';


@Injectable({providedIn: 'root'})
export class NavigationService {

  constructor() { }

  getNavigation (project: ProjectModel, features: any): any {
    const navigation = Configuration.getNavigation();
    if (project) {
      navigation.forEach((nav: any) => {
        nav.children.forEach(child => {
          child.enabled = true;
          if (child.children) {
            child.children.forEach(innerChild => {
              innerChild.enabled = true;
            });
          }
        });
      });
    }
    if (features) {
      this.updateMenuItems(navigation, features);
    }
    return navigation;
  }

  updateMenuItems (nav: any, features: any) {
    nav.forEach(x => {
      this.recursiveUpdateOfMenuItem(features, x);
    });
  }

  recursiveUpdateOfMenuItem (features: any, item: any) {

    item.hidden = false;

    if (item.featureId && !features[item.featureId]) { // don't use false comparison because it's undefined
      item.hidden = true;
    }

    let childCount = 0;
    if (item.children) {
      item.children.forEach(x => {
        childCount += this.recursiveUpdateOfMenuItem(features, x);
      });
    }

    if (childCount <= 0 && item.type !== 'item') {
      item.hidden = true;
    }

    if (!item.hidden) {
      return 1;
    }

    return 0;
  }
}


